import { useEffect, useState } from "react";

import getDimensions from "../api/getDimensions";

import useMetricsContext from "./useMetricsContext";

import type { MetricsRange, MetricsStream } from "../resources/types";

export type Query = {
  stream: MetricsStream;
  range: MetricsRange;
};

const useDimensions = (chorusURL?: string, query?: Query) => {
  const [state, setState] = useState<{
    dimension: Record<string, string>[] | null;
    isLoadingDimensions: boolean;
    dimensionError: any;
  }>({ dimension: null, isLoadingDimensions: false, dimensionError: null });

  const setError = useMetricsContext()?.setError;

  useEffect(() => {
    if (chorusURL && query?.stream?.collection) {
      setState(() => ({
        dimension: null,
        isLoadingDimensions: true,
        dimensionError: null
      }));

      getDimensions(chorusURL, query)
        .then(data =>
          setState(() => ({
            dimension: data,
            isLoadingDimensions: false,
            dimensionError: null
          }))
        )
        .catch(error => {
          setError?.(error);
          setState(() => ({
            dimension: null,
            isLoadingDimensions: false,
            dimensionError: error
          }));
        });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [chorusURL, query?.stream?.collection]);

  return state;
};

export default useDimensions;
